$.ajaxSetup({cache: false});

// ── Every app endpoint is ROOT-relative, whatever path the page is served from ───────────────────
//
// ⛔ The legacy SPA asks for its endpoints by BARE name — $.ajax("user-attr-save"),
// $.getJSON("api/srs/motor-params"), ajaxPost("dictionary/seek"), "wordlist-load" and a few dozen
// more. A relative URL resolves against the PAGE's directory, and for eleven years every page that
// ran this code was served from "/", so "dictionary/seek" and "/dictionary/seek" were the same
// string and nobody had to think about it.
//
// The guest app page is the first one that is not: /en/de/app is served from /en/de/, so every one
// of those calls asked for /en/de/api/... and got a 404 — the app booted, painted, and then
// silently had no data at all, with an app-level "Not found" box over it (found by the entry-flow
// smoke harness, 2026-09-09; docs/project/entry-flow-redesign.md PR 2). Rewriting the several
// dozen call sites would be a change with no end to it and one missed line would look exactly like
// this bug; the honest fix is to say the rule once, here, where every jQuery request passes.
//
// A no-op on every page that was already at "/": "api/x" and "/api/x" resolve identically there.
// Absolute URLs, protocol-relative URLs and anything with a scheme are left alone.
$.ajaxPrefilter(function (options) {
	var url = options.url;
	if (typeof url === "string" && url && url.charAt(0) !== "/" && !/^[a-z][a-z0-9+.-]*:|^\/\//i.test(url)) {
		options.url = "/" + url;
	}
});

// ── A 401 means this browser has no user any more — go back to the landing ───────────────────────
//
// The server side of this landed 2026-09-02 (docs/project/go-public-hardening.md §3 F5): the
// interceptor stopped MINTING a temp user for every cookie-less request. Until then a lost session
// healed itself invisibly — the next API call simply created a new user and carried on, which is
// also what made every bot request cost ~47 rows. Now such a call gets a 401, and this is what
// heals the state instead: one hop to `/`, which renders the landing for a visitor with no
// identity and hands the app straight back to one who has a valid `rt` cookie.
//
// `location.replace`, not `href`: the page being abandoned is one the user cannot use, so it has
// no business in the back button.
//
// ⛔ /api/auth/** is excluded, and the exclusion is load-bearing rather than tidy. A 401 there is a
// NORMAL, expected answer that means "not signed in" — `login_main.js` reads it that way to draw
// the guest avatar, and the /login page asks the same question of a visitor who by definition has
// no account yet. Redirecting on those would send anyone opening /login straight back to `/`.
//
// Everything else answers 401 only through UserException.Code.NOT_LOGGED_IN (or AuthController's
// own two), i.e. only when the session genuinely has no user — so "any non-auth 401" is the honest
// test, and it needs no list of endpoint prefixes to keep in step with the routes. It also works
// for the legacy calls that pass a RELATIVE url ("user-attr-save"), which a prefix list would miss.
(function () {
	var leaving = false;
	$(document).ajaxError(function (event, jqXHR, settings) {
		if (leaving || !jqXHR || jqXHR.status !== 401) {
			return;
		}
		var url = (settings && settings.url) || "";
		if (url.indexOf("/api/auth/") >= 0) {
			return;
		}
		leaving = true;
		window.location.replace("/");
	});
})();
// `failure` (optional) takes over the error path entirely: it is called INSTEAD of showing the
// message box, for a caller whose request is a background nicety rather than the thing the user
// asked for, and which has its own way to carry on without it.
// `complete` (optional) runs after success OR error, whichever the request ends in — for a caller
// that has to know the request is off the wire regardless of what it returned (ajaxPostUserAttr's
// per-attribute queue).
function ajaxPost(url, params, success, errorMsg, failure, complete) {
	var atn = getCookie("atn");
	if (!atn) {
		//if cookies are disable, rewrite url
		var href = document.location.href;
		var start = href.indexOf(";");
		if (start >= 0) {
			url += href.substring(start);//for session tracking if cookies disabled
		}
	}
	$.ajax(url, {
		type: "POST",
		data: params,
		dataType: "json",
		traditional: true,
		success: function (data) {
			//this is success
			if (success) {
				success(data);
			}
		},
		error: function (jqXHR) {
			if (failure) {
				failure(jqXHR);
				return;
			}
			var data = "";
			var errorMsg = "";
			if (jqXHR.responseText) {
				data = $.parseJSON(jqXHR.responseText)
			}
			if (data.actionErrors && data.actionErrors.length > 0) {
				//this is error
				for (var i = 0; i < data.actionErrors.length; i++) {
					if (i > 0) {
						errorMsg += "\n";
					}
					errorMsg += data.actionErrors[i];
				}
			} else if (data.error) {
				errorMsg = data.error;
			} else if (data.redirect) {
				//redirect (most likely to login page)
				window.location.replace(data.redirect);
				return;
			} else {
				//backup error message (should not be called normally)
				errorMsg = getRes("error") + " [requested url: " + url + "]";
			}
			showMessage(errorMsg);
		},
		complete: function () {
			if (complete) {
				complete();
			}
		}
	});
}

// ONE request in flight per ATTRIBUTE, last value wins.
//
// Two writes of the same attr in one tick are a normal pattern, not a corner case: closing one word
// list and opening another writes myListValId twice (main.js collapseSection + expandSection —
// which the guided walk's `panelDo("collapse"); panelDo("open", …)` does on a single step), and the
// two settings checkboxes that re-post a sibling do the same.
//
// Sent as two concurrent POSTs they landed on ONE user_attr row: Hibernate's optimistic lock
// (updated_ts is the @Version column) made the loser a 500 in the browser and an
// ObjectOptimisticLockingFailureException in the log (owner report 2026-08-13), and whichever
// request happened to finish last decided what a reload would restore — so the panel could come
// back all-collapsed after opening a list. Queued instead: while an attr's POST is out, a further
// save keeps only the LATEST value and goes out when the first returns. The callbacks of the writes
// that were folded together all run on that final response — none is dropped, and none is answered
// before the value it asked for is actually stored.
//
// Per attribute, not global: two DIFFERENT attrs are two different rows and never race.
var userAttrInFlight = {};   // attr name -> true while its POST is on the wire
var userAttrPending = {};    // attr name -> { val, cbs } waiting behind it

function ajaxPostUserAttr(attrName, attrVal, success) {
	if (!success) {
		success = function () {
			//do nothing
			return true;
		}
	}
	if (userAttrInFlight[attrName]) {
		var q = userAttrPending[attrName];
		if (q) {
			q.val = attrVal;
			q.cbs.push(success);
		} else {
			userAttrPending[attrName] = {val: attrVal, cbs: [success]};
		}
		return;
	}
	postUserAttr(attrName, attrVal, [success]);
}

function postUserAttr(attrName, attrVal, cbs) {
	var params = {};
	params[attrName] = attrVal;
	userAttrInFlight[attrName] = true;
	ajaxPost("user-attr-save", params,
		function (data) {
			for (var i = 0; i < cbs.length; i++) {
				cbs[i](data);
			}
		},
		"Cannot save the setting [" + attrName + "=" + attrVal + "]",
		null,
		function () {
			delete userAttrInFlight[attrName];
			var q = userAttrPending[attrName];
			if (q) {
				delete userAttrPending[attrName];
				postUserAttr(attrName, q.val, q.cbs);
			}
		})
}

function toBoolean(bool) {
	return bool === true || bool === "true";
}

function setCookie(name, value) {
	$.cookie(name, value, {expires: 365 * 5});
//			alert("Store cookie, name=" + name + "; value=" + value);
}

function getCookie(name) {
//		alert("Read cookie, name=" + name + "; cookie=" + cookie);
	return $.cookie(name);
}

function deleteCookie(name) {
	setCookie(name, null);
}

$.fn.getId = function () {
	return $(this).attr("id");
};

$.fn.setId = function (id) {
	return $(this).attr("id", id);
};

$.fn.focusToEnd = function () {
	return this.each(function () {
		var v = $(this).val();
		$(this).focus().val("").val(v);
	});
};

$.fn.disableField = function (disable) {
	return this.each(function () {
		var field = $(this);
		if (disable) {
			field.attr("disabled", true);
			field.addClass("disabledBackground");
		} else {
			field.removeAttr("disabled");
			field.removeClass("disabledBackground")
		}
	});
};

$.fn.widthAttr = function (width) {
	var elem = $(this);
	if (width) {
		elem.css("width", width);
	}
	return elem.css("width");
};

$.fn.heightAttr = function (height) {
	var elem = $(this);
	if (height) {
		elem.css("height", height);
	}
	return elem.css("height");
};

$.fn.flashClass = function (className, time, delay, easingIn, easingOut) {
	if (time === undefined) {
		time = 100;
	}
	if (delay === undefined) {
		delay = 100;
	}
	if (easingIn === undefined) {
		easingIn = 500;
	}
	if (easingOut === undefined) {
		easingOut = 500;
	}
	var that = $(this);
	// Phase 4 step 6b: the animated addClass/removeClass came from jQuery UI's effects
	// core; the flash now rides a temporary INLINE transition. transitioned() flushes a
	// reflow first so class changes made before it (the transparent on/off snaps, kept
	// from the legacy timeline) apply instantly and only the flash class animates.
	// Fade-in easing was jQuery "swing", now the CSS default "ease" (visual ε).
	// Returns the delay-timer id like before — callers clearTimeout a not-yet-started
	// flash (help highlight hover-off); once running, a flash always completes.
	function transitioned(durationAndEasing, change) {
		that.each(function () { void this.offsetWidth; });
		that.css("transition", "all " + durationAndEasing);
		change();
	}
	return setTimeout(function () {
		var hasTransparentClass = that.hasClass("transparent");
		if (hasTransparentClass) {
			that.removeClass('transparent');
		}
		transitioned(easingIn + "ms", function () {
			that.addClass(className);
		});

		setTimeout(function () {
			if (hasTransparentClass) {
				that.css("transition", "none");
				that.addClass("transparent");
			}
			transitioned(easingOut + "ms linear", function () {
				that.removeClass(className);
			});
			setTimeout(function () {
				that.css("transition", "");
			}, easingOut);
		}, time);
	}, delay);
};

jQuery.fn.assignTooltip = function (resKeyOrFunction, events) {
	// PR 5/7 of the tooltip engine: this is now a THIN SHIM over PL.tip.attach — the
	// trigger wiring, the show intent, the text resolution, the hide-event list and the
	// placement all live in js/pl/tip.js, where the two presentations of design §2.1 can
	// pick between themselves at show time. The ~110 call sites keep their exact call
	// signature, and every one of them gains guided rendering for free.
	//
	// The walk's supersede guard (OB_GUIDE.owns / cueLive) came along that far and then
	// died in PR 6/7: the walk's cue is a PL.tip.pin now, and "no ordinary tooltip while
	// an explanation is pinned" is simply its group priority (design §4.3). Nothing here
	// calls back into the onboarding walk any more.
	//
	// Two things this shim no longer does, both on purpose:
	// - it no longer builds ONE tip anchored at the COLLECTION's first element while
	//   binding the hover to all of them (so hovering the 2nd of three IPA buttons put
	//   the box under the 1st). attach() takes the whole collection, keeps ONE instance
	//   and ONE hover machine for it, and anchors to whichever element was entered;
	// - it no longer places from jQuery offset() — DOCUMENT coordinates on a
	//   position:fixed box, which was off by the scroll on a scrolled window. The engine
	//   anchors to the element itself. (PR 1/7 kept the quirk deliberately until this
	//   port; docs/design/tooltip-engine-consolidation.md §4.5.)
	var elem = $(this);
	// No placement options: the engine's own defaults for this surface ARE the legacy
	// rule (below the trigger, left edges flush, 10px off) — and leaving them unstated is
	// what lets the bigger guided box flip above/beside a control near a viewport edge.
	// Bound through jQuery, not addEventListener: these call sites inherited jQuery's event
	// contract, and app code that arms or dismisses a control with $(el).trigger("mouseenter")
	// (or the legacy `events` parameter, which is a jQuery event string) must keep working.
	var opts = { events: events, on: function (el, name, fn) { $(el).on(name, fn); } };
	if ($.isFunction(resKeyOrFunction)) {
		opts.content = function () { return resKeyOrFunction(); };
	} else {
		opts.key = resKeyOrFunction;   // …and the engine falls back to the key itself
	}
	PL.tip.attach(elem, opts);
	return elem;
};
if (typeof String.prototype.startsWith != 'function') {
	String.prototype.startsWith = function (str) {
		return this.slice(0, str.length) == str;
	};
}

function removeFirstText(elem) {
	if (elem) {
		var firstChild = elem[0].firstChild;
		if (firstChild && firstChild.nodeType == 3) {
			//remove previous value
			elem[0].removeChild(firstChild);
		}
	}
}

function getFirstText(elem) {
	if (elem && elem[0].firstChild) {
		return elem[0].firstChild.textContent;
	} else {
		return "[not defined]";
	}
}

// Replace {0}, {1}, {2} … placeholders in a template string with the given arguments.
function strFormat(template) {
	var args = Array.prototype.slice.call(arguments, 1);
	return template.replace(/\{(\d+)\}/g, function(m, i) {
		return args[i] !== undefined ? args[i] : m;
	});
}

// A count, written the way the UI language writes it: 24000 → "24,000" in English, «24 000» in
// Russian, "24.000" in German, "24 000" in French, "24.000" in Spanish (but "1000" at four digits —
// that is the RAE rule, and Intl implements it). docs/project/i18n-runtime-grammar.md §4.3: the
// JS engine had no number formatting at all, so `stats_coverage` rendered a raw "1000" beside a
// tooltip that said "1,000" — an inconsistency visible in ENGLISH, before any locale is involved.
//
// `curr_locale` is "" for English (the default bundle, see getRes above), hence the || "en".
//
// ⛔ NON-NUMBERS PASS THROUGH UNTOUCHED, deliberately. Several count slots are handed a composed
// phrase rather than a number — session_history.js gives hist_ws_count / audit_words_count either
// String(rows.length) or "12 of 1234" — and grouping must not touch those. Same reason a plural
// helper cannot key on those two slots until they are restructured.
// The locale tag every Intl / toLocale* call in this app must use: the APP's UI language, never
// the browser's. Owner ruling 2026-09-01 (docs/project/i18n-runtime-grammar.md §5.3) — the pill
// the user set decides how a number and a date are written, exactly as it decides every other
// string on the page. Before it, numbers followed the app and dates followed the browser, so a
// Russian UI on an en-US machine showed «24 000 слов» beside «9/1/2026» in one panel.
//
// `curr_locale` is "" for English (the default bundle, see getRes above), hence the || "en".
function localeTag() {
	return (typeof curr_locale !== "undefined" && curr_locale) ? curr_locale : "en";
}

function fmtNum(n) {
	if (typeof n !== "number" || !isFinite(n)) { return n; }
	try {
		return new Intl.NumberFormat(localeTag()).format(n);
	} catch (e) {
		return String(n);   // no Intl, or a locale it refuses: the bare number still reads
	}
}

// A language's name as THIS READER's language writes it: "German" for an English reader,
// «немецкий» for a Russian one — never the endonym "Deutsch".
//
// docs/project/i18n-runtime-grammar.md §4.1. Until 2026-09-01 the SPA had no such lookup: it read
// the language picker's visible text, which is Language.getNameNative(), and spliced that endonym
// into 21 localized sentences — «Всё, что вы изучали в Deutsch», and "studied in Deutsch" for an
// English reader too. The server side never had the bug: it resolves `lang.name.<CODE>` in the
// reader's locale, and PublicUrlSchemeTest guards it.
//
// `lang_names` is that same resolution, inlined by main.html from TipService — one engine, so the
// tips page and the SPA can never disagree about what a language is called. `fallback` is what the
// caller would have shown otherwise, for pages that do not inline the map.
function langDisplayName(code, fallback) {
	var names = (typeof lang_names !== "undefined") ? lang_names : null;
	var named = (names && code) ? names[code] : null;
	return named || fallback || code || "";
}

function getBoldBlue(text) {
	return "<span class='boldBlue'>" + text + "</span>";
}

// Inline Lucide icon (components/icons.css): 1em square, painted with currentColor.
// `name` must match a .pl-ic-<name> class (which maps to /image/lucide/<file>.svg).
function plIcon(name) {
	return "<span class='pl-ic pl-ic-" + name + "'></span>";
}

// Resolve a --pl-* design token to [r, g, b] (any CSS color syntax — the browser
// normalizes it via a probe element). Cached: tokens don't change within a page life.
function plTokenColor(name) {
	var cache = plTokenColor._cache || (plTokenColor._cache = {});
	if (cache[name]) {
		return cache[name];
	}
	var probe = $("<span>").css({ display: "none", color: "var(" + name + ")" }).appendTo("body");
	var m = probe.css("color").match(/\d+/g);
	probe.remove();
	var rgb = m ? [+m[0], +m[1], +m[2]] : [0, 0, 0];
	cache[name] = rgb;
	return rgb;
}

function toggleErrorHighlight(elem, invalid, errorMsg, tip) {
	if (invalid) {
		elem.addClass("errorBackground");
		if (errorMsg) {
			var position = elem.offset();
			var left = position.left + 100;
			var top = position.top - 15;
			if (tip) {
				tip.setPosition(left, top);
				tip.show(getRes(errorMsg));
			}
		}
	} else {
		elem.removeClass("errorBackground");
		if (tip) {
			tip.hide();
		}
	}
	return invalid;
}

function getRes(resName) {
	// T-16 (docs/project/tablet-support-plan.md §4): the finger's copy ("Tap" for "Click"). PL.resKey is
	// unset on a desktop; js/touch/copy.js sets it.
	if (window.PL && PL.resKey) {
		resName = PL.resKey(resName);
	}
	//curr_locale in initialized at the beginning of all jsp pages
	var resources = document["res_" + curr_locale];
	if (!resources) {//get default file (English)
		resources = document["res_"];
	}
	var localizedName;
	if (resources) {
		localizedName = resources[resName];
	}
	if (!localizedName) {//get the name from default file (i.e. English)
		localizedName = document["res_"][resName];
	}
	if (!localizedName) {
		localizedName = resName;//show the key
	}

	return  localizedName;
}

// COOKIE_PERM_USER / COOKIE_ATN and the Encode helper (base64 + MD5) lived here to remember a
// username between visits and hash a password before sending it. Both went with changeset 0103:
// there is no password, and the address is typed fresh each time. Nothing else in the app used
// them — and their removal takes the last CryptoJS caller with it, which is why the three
// cryptojs/*.js tags came off the pages too. This file must stay loadable with no library present:
// a top-level reference to a missing global throws and takes every function below it down with it
// (CLAUDE.md gotcha 1).